import { YesObject } from '@yes.technology/react-toolkit'
import { cloneDeep } from 'lodash'
import splitIntoChunks from 'shared/utils/array/splitIntoChunks'
import {
  AssociatedUsersRelationsKeys,
  ColumnProps,
  LayoutProps
} from './Kanban.types'

type ResolveAssociationReadableNameParams = {
  association: {
    relation: AssociatedUsersRelationsKeys
    readableName?: string
  }
  fieldSettingsLabel?: string
  defaultRelationReadableName?: string
  objectclassLabel?: string
}

export function resolveAssociationReadableName({
  association,
  fieldSettingsLabel,
  defaultRelationReadableName,
  objectclassLabel
}: ResolveAssociationReadableNameParams) {
  if (association.readableName) {
    return association.readableName
  }

  if (fieldSettingsLabel) {
    return fieldSettingsLabel
  }

  if (defaultRelationReadableName) {
    return defaultRelationReadableName
  }

  return objectclassLabel
}

export function getSectionsByLayout(
  layoutSections: LayoutProps['sections']
): [string[] | undefined, Record<string, ColumnProps>] {
  if (!layoutSections) return [undefined, {}]

  const keys: string[] = []
  const columnMap: Record<string, ColumnProps> = {}

  for (const section of layoutSections) {
    for (const column of section.columns) {
      keys.push(column.grouped_by_value)
      columnMap[column.grouped_by_value as string] = column
    }
  }

  return [keys, columnMap]
}

export function getNewTaskColumnIndex({
  columns,
  pageColumns,
  newStatusColumn
}: {
  columns: string[]
  pageColumns: number
  newStatusColumn: string
}) {
  const splittedColumns = splitIntoChunks(columns, pageColumns)
  const columnSectionIndex = splittedColumns.findIndex(
    (columns) => !!columns.find((column) => column === newStatusColumn)
  )

  return columnSectionIndex
}

export function updateTaskColumn({
  objects,
  taskUuid,
  newStatusColumn,
  groupByField = 'uuid_status'
}: {
  objects: YesObject[]
  taskUuid: string
  newStatusColumn: string
  groupByField?: string
}) {
  const clonedObjects = cloneDeep(objects)

  const taskIndex = clonedObjects.findIndex(({ uuid }) => uuid === taskUuid)

  if (taskIndex >= 0) {
    clonedObjects.splice(taskIndex, 1, {
      ...clonedObjects[taskIndex],
      [groupByField]: newStatusColumn
    })
  }

  return clonedObjects
}

export function groupByCode(
  objects: YesObject[],
  mutableObjects: YesObject[],
  groupByField: string
) {
  return objects.reduce(
    (acc, relationObject) => {
      return {
        ...acc,
        [relationObject.code as string]: mutableObjects.filter(
          (yesObject) => yesObject[groupByField] === relationObject.code
        )
      }
    },
    {} as Record<string, YesObject[]>
  )
}
